var map = {
	"./Brand/Index.vue": [
		"095d",
		"chunk-0cd3a036",
		"chunk-2d0a4f8e"
	],
	"./Customer/Index.vue": [
		"3ddc",
		"chunk-0cd3a036",
		"chunk-2d0c53c6"
	],
	"./Device/Index.vue": [
		"6387",
		"chunk-0cd3a036",
		"chunk-2d0cf372"
	],
	"./Dispatch/Index.vue": [
		"5554",
		"chunk-0cd3a036",
		"chunk-85d8808e"
	],
	"./Expenses/Index.vue": [
		"9118",
		"chunk-0cd3a036",
		"chunk-06161b2b"
	],
	"./HirePurchase/Index.vue": [
		"b4e5",
		"chunk-0cd3a036",
		"chunk-2d20fcf8"
	],
	"./InventoryTransfer/Index.vue": [
		"cff9",
		"chunk-0cd3a036",
		"chunk-2d222d2c"
	],
	"./Location/Index.vue": [
		"c52f",
		"chunk-0cd3a036",
		"chunk-2d216f1c"
	],
	"./Log/Index.vue": [
		"c327",
		"chunk-c95530fe",
		"chunk-005a2ade",
		"chunk-4a17bf41"
	],
	"./Order/Index.vue": [
		"02fe",
		"chunk-0cd3a036",
		"chunk-7a65c1dc"
	],
	"./OrderType/Index.vue": [
		"c6bd",
		"chunk-0cd3a036",
		"chunk-2d2178ab"
	],
	"./PaymentType/Index.vue": [
		"948d",
		"chunk-0cd3a036",
		"chunk-2d0e547d"
	],
	"./Product/Index.vue": [
		"3b75",
		"chunk-0cd3a036",
		"chunk-766bfd84"
	],
	"./ProductAttribute/Index.vue": [
		"0f4f",
		"chunk-0cd3a036",
		"chunk-2d0af85e"
	],
	"./ProductCategory/Index.vue": [
		"5522",
		"chunk-0cd3a036",
		"chunk-5680a963"
	],
	"./ProductTag/Index.vue": [
		"1bad",
		"chunk-0cd3a036",
		"chunk-2d0b632a"
	],
	"./Promotion/Index.vue": [
		"2351",
		"chunk-0cd3a036",
		"chunk-2d0b2193"
	],
	"./PurchaseOrders/Index.vue": [
		"7318",
		"chunk-0cd3a036",
		"chunk-2d0d66f9"
	],
	"./ReceivingReport/Index.vue": [
		"00d2",
		"chunk-0cd3a036",
		"chunk-2d0a3344"
	],
	"./Reporting/Index.vue": [
		"3100",
		"chunk-2d0b8dd4"
	],
	"./Return/Index.vue": [
		"5ac1",
		"chunk-0cd3a036",
		"chunk-2d0d30f0"
	],
	"./StocktakingEvent/Index.vue": [
		"e2c1",
		"chunk-0cd3a036",
		"chunk-2d225251"
	],
	"./SuperAdmin/Index.vue": [
		"2df6",
		"chunk-2d0bdf78"
	],
	"./Supplier/Index.vue": [
		"11f0",
		"chunk-0cd3a036",
		"chunk-2d0aaba0"
	],
	"./User/Index.vue": [
		"4b36",
		"chunk-0cd3a036",
		"chunk-2d0cba87"
	],
	"./UserType/Index.vue": [
		"5b07",
		"chunk-0cd3a036",
		"chunk-2d0d2e8a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3b5e";
module.exports = webpackAsyncContext;